var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAttachmentUpload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 67.534,
    height: 58,
    viewBox: "0 0 67.534 58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "attachment",
    transform: "translate(0 -2)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5519",
    "data-name": "Path 5519",
    d: "M53.9,8.029H27.25a4.21,4.21,0,0,1-2.894-1.206L20.98,3.206A3.74,3.74,0,0,0,18.086,2H3.979A4.014,4.014,0,0,0,0,5.979v37.86a4.014,4.014,0,0,0,3.979,3.979H53.9a4.014,4.014,0,0,0,3.979-3.979V12.008A4.014,4.014,0,0,0,53.9,8.029Z",
    fill: "#5e75e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5520",
    "data-name": "Path 5520",
    d: "M52.118,8.8H4.853A2.676,2.676,0,0,0,2.2,11.453V33.035H54.77V11.453A2.676,2.676,0,0,0,52.118,8.8Z",
    transform: "translate(0.453 1.399)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5521",
    "data-name": "Path 5521",
    d: "M3.979,17.029H30.626a4.21,4.21,0,0,0,2.894-1.206L36.9,12.206A3.74,3.74,0,0,1,39.789,11H54.017A4.014,4.014,0,0,1,58,14.979V49.222A4.014,4.014,0,0,1,54.017,53.2H3.979A4.014,4.014,0,0,1,0,49.222V21.008A4.014,4.014,0,0,1,3.979,17.029Z",
    transform: "translate(0 1.852)",
    fill: "#6781ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5522",
    "data-name": "Path 5522",
    d: "M25.008,16.413,5.836,23.527a1.254,1.254,0,0,0-.723,1.567l7.6,20.618a1.254,1.254,0,0,0,1.567.723l19.171-7.114a1.254,1.254,0,0,0,.723-1.567l-7.6-20.618A1.254,1.254,0,0,0,25.008,16.413Z",
    transform: "translate(1.036 2.95)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5523",
    "data-name": "Path 5523",
    d: "M24.464,18.345,30.9,35.762,13.482,42.2,7.047,24.78Z",
    transform: "translate(1.45 3.363)",
    fill: "#6179ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5524",
    "data-name": "Path 5524",
    d: "M21.564,12.776a3.376,3.376,0,1,0-6.752,0v9.4a2.05,2.05,0,1,0,4.1,0v-8.32a.6.6,0,1,0-1.206,0v8.32a.723.723,0,1,1-1.447,0v-9.4a2.05,2.05,0,0,1,4.1,0v4.582h1.206V12.776Zm-7.958,3.256a.6.6,0,1,0-1.206,0v1.326h1.326V16.032Z",
    transform: "translate(2.551 1.522)",
    fill: "#566fe8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6580",
    "data-name": "Group 6580",
    transform: "translate(50.822 43.389)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_2769",
    "data-name": "Ellipse 2769",
    transform: "translate(-0.287 -0.389)",
    fill: "#fff",
    stroke: "#ccd5ff",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 7,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "_9035016_warning_icon",
    "data-name": "9035016_warning_icon",
    d: "M90.349,98.087a.675.675,0,1,1,.675-.675A.675.675,0,0,1,90.349,98.087Zm.733-6.788-.194,4.117a.54.54,0,0,1-1.08,0L89.614,91.3h0a.733.733,0,0,1,.726-.766h.007a.734.734,0,0,1,.733.766Z",
    transform: "translate(-82.071 -86.034)",
    fill: "#3454ef"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachmentUpload);
export default __webpack_public_path__ + "static/media/attachmentUpload.f8b0d4ac9f3a84a0d089601aebaf8dd6.svg";
export { ForwardRef as ReactComponent };